export enum AvailableUserType {
  All = 1,
  AnyOne = 2,
}
